import React from 'react';
import Text from 'components/Text';
import { Row, Column } from 'components/Layout/Grid';
import RadioInput from 'components/RadioInput';
import Validator from 'components/Validator';
import { CommunicationChannelProps } from './interface';

export const CommunicationChannel: React.FC<CommunicationChannelProps> = (props) => {
  const { communicationChannel, setCommunicationChannel, optionalButtonsTypes } = props;

  return (
    <Column className="my-5">
      <Text className="mb-2 color-blue-gray" size={12}>
        Canal de Contato
      </Text>
      <Validator
        value={communicationChannel}
        name="Canal de contato"
        required
      >
        <Row className="flex-md-column">
          {
            optionalButtonsTypes.map((el, index) => (
              <Row
                key={index}
                className="w-md-100 mt-md-2 mr-4"
              >
                <RadioInput
                  id={el.key}
                  onClick={() => setCommunicationChannel(el.key)}
                  checked={communicationChannel === el.key}
                  title="communicationChannel"
                >
                  <Text className="color-blue-gray">{el.value}</Text>
                </RadioInput>
              </Row>
            ))
          }
        </Row>
      </Validator>
    </Column>
  );
};